import request from '@/utils/request'

// 查询客户编号列表
export function listCustomer(query) {
  return request({
    url: '/tram/tram-customer/list',
    method: 'get',
    params: query
  })
}

// 查询客户编号分页
export function pageCustomer(query) {
  return request({
    url: '/tram/tram-customer/page',
    method: 'get',
    params: query
  })
}

// 查询客户编号详细
export function getCustomer(data) {
  return request({
    url: '/tram/tram-customer/detail',
    method: 'get',
    params: data
  })
}

// 新增客户编号
export function addCustomer(data) {
  return request({
    url: '/tram/tram-customer/add',
    method: 'post',
    data: data
  })
}

// 修改客户编号
export function updateCustomer(data) {
  return request({
    url: '/tram/tram-customer/update',
    method: 'post',
    data: data
  })
}

// 删除客户编号
export function delCustomer(data) {
  return request({
    url: '/tram/tram-customer/delete',
    method: 'post',
    data: data
  })
}
// 绑定版本
export function edit(data) {
  return request({
    url: '/tram/tram-customer/edit',
    method: 'post',
    data: data
  })
}
// 解除版本
export function unbindtoa(data) {
  return request({
    url: '/tram/tram-customer/unbind',
    method: 'post',
    data: data
  })
}